<template>
	<page>
		<module height="auto" :title="'订单：'+orderDetail.order_number+' 详情'">
			<div class="flex-between">
				<dl class="order-info">
					<dt>交易信息</dt>
					<dd>
						<div class="order-info-item flex">
							<label>订单编号：</label>
							<p>{{orderDetail.order_number}} <a @click="$copy(orderDetail.order_number)">复制</a></p>
						</div>
						<div class="order-info-item flex">
							<label>运营模式：</label>
							<p>{{orderDetail.operation_mode==1?'平台自营':'商家自营'}}</p>
						</div>
						<div class="order-info-item flex">
							<label>下单时间：</label>
							<p>{{orderDetail.create_date}} <!-- <a>更多</a> --></p>
						</div>
					</dd>
				</dl>
				
				<dl class="order-info">
					<dt>买家信息</dt>
					<dd>
						<div class="order-info-item flex">
							<label>买家留言：</label>
							<p>{{orderDetail.order_remark?orderDetail.order_remark:'--'}}</p>
						</div>
                        <div class="order-info-item flex" v-if="orderDetail.order_type == 7">
                          <label>定制附件：</label>
                          <p class="flex">
                            <template v-if="cusTomInfo.custom_attach_url">
                              <c-file v-for="(item, i) in cusTomInfo.custom_attach_url.split(',')" :key="i" :src="item" media style="width: 50px; height: 50px;"></c-file>
                            </template>
                          </p>
                        </div>
						<div class="order-info-item flex" v-if="orderDetail.order_type == 7">
							<label>定制备注：</label>
							<p>{{cusTomInfo.custom_remark?cusTomInfo.custom_remark:'--'}}</p>
						</div>
					</dd>
				</dl>
				
				<dl class="order-info">
					<dt>物流信息</dt>
					<dd>
						<div class="order-info-item flex">
							<label>收货人：</label>
							<p>{{orderDetail.receiving_name}}，{{orderDetail.receiving_phone}}</p>
						</div>
						<div class="order-info-item flex">
							<label>收货地址：</label>
							<p>{{orderDetail.receiving_address}}</p>
						</div>
						<div class="order-info-item flex">
							<label>配送方式：</label>
							<p>{{orderDetail.logistics_company_name}}</p>
						</div>
						<!-- <div class="order-info-item flex" v-if="orderDetail.order_state == 3 || orderDetail.order_state == 5">
							<label>发货时间：</label>
							<p>{{orderDetail.send_dates}}</p>
						</div>
						<div class="order-info-item flex" v-if="orderDetail.order_state == 3 || orderDetail.order_state == 5">
							<label>运单号：</label>
							<p>{{orderDetail.logistics_numbers}}</p>
						</div> -->
					</dd>
				</dl>
			</div>
		</module>
		
		<module>
			<div class="order-detail">
				<c-table v-if="orderDetail" :data="productList" :paging="false" border>
					<c-table-column
						label="商品信息"
						width="300"
					>
                        <template #default="{data}">
                            <product-info v-if="data.product_itemnumber" :image="data.product_img_url" :name="data.product_itemnumber + ' - '+data.product_name"></product-info>
                            <product-info v-else :image="data.product_img_url" :name="data.product_name"></product-info>
                        </template>
					</c-table-column>
					
					<c-table-column
						label="规格名"
						width="110"
					>
						<template v-slot="{data}">
							{{data.product_sku_spec}}
						</template>
					</c-table-column>
					
					<c-table-column
						label="商品SKU编码"
						width="120"
					>
						<template v-slot="{data}">
							{{data.product_sku_code?data.product_sku_code:'--'}}
						</template>
					</c-table-column>
					
					<c-table-column
						label="单价"
					>
						<template v-slot="{data}">
							￥{{data.product_cost_money/data.product_count}}
						</template>
					</c-table-column>
					
					<c-table-column
						label="数量"
						width="80"
					>
						<template v-slot="{data}">
							×{{data.product_count}}
						</template>
					</c-table-column>
					
					<c-table-column
						label="小计"
					>
						<template v-slot="{data}">
							{{data.product_cost_money}}
						</template>
					</c-table-column>

                    <c-table-column
                            label="未发退款数"
                    >
                        <template v-slot="{data}">
                            {{data.total_refund_count}}
                        </template>
                    </c-table-column>

                    <c-table-column
                            label="已发退货数"
                    >
                        <template v-slot="{data}">
                            {{data.total_return_count}}
                        </template>
                    </c-table-column>
					
					<c-table-column
						label="已发货"
					>
						<template v-slot="{data}">
							<span style="color:#598419;;font-size:22px;" v-if="data.send_count>0">{{data.send_count}}</span>
							<span v-else>{{data.send_count}}</span>
						</template>
					</c-table-column>
					<c-table-column
						label="待发货"
					>
						<template v-slot="{data}">
							<span style="color:red;font-size:22px;" v-if="(data.product_count - data.send_count - data.total_refund_count)>0">{{data.product_count - data.send_count - data.total_refund_count}}</span>
							<span v-else>{{data.product_count - data.send_count - data.total_refund_count}}</span>
						</template>
					</c-table-column>
					
					<c-table-column
						label="重量小计(克)"
						width="100"
					>
						<template v-slot="{data}">
							{{data.product_weight?data.product_weight:'--'}}
						</template>
					</c-table-column>
                    <div class="order-total flex-between-center">
                        <div>
                            待发货商品总数：<span><b>{{waitSendProductTotal}}</b></span>
                        </div>
                    </div>
				</c-table>
				<div style="height:20px;"></div>
				<c-table v-if="giftProductList.length > 0" :data="giftProductList" height="auto" :paging="false" border>
					<c-table-column
						label="赠品商品信息"
						width="300"
					>
                        <template #default="{data}">
                            <product-info v-if="data.product_itemnumber" :image="data.product_img_url" :name="data.product_itemnumber + ' - '+data.product_name"></product-info>
                            <product-info v-else :image="data.product_img_url" :name="data.product_name"></product-info>
                        </template>
					</c-table-column>
					
					<c-table-column
						label="规格名"
						width="150"
					>
						<template v-slot="{data}">
							{{data.product_sku_spec}}
						</template>
					</c-table-column>
					
					<c-table-column
						label="商品SKU编码"
						width="120"
					>
						<template v-slot="{data}">
							{{data.product_sku_code?data.product_sku_code:'--'}}
						</template>
					</c-table-column>
					
					<c-table-column
						label="数量"
						width="100"
					>
						<template v-slot="{data}">
							×{{data.product_count}}
						</template>
					</c-table-column>
					
					<c-table-column
						label="重量小计(克)"
						width="100"
					>
						<template v-slot="{data}">
							{{data.product_weight?data.product_weight:'--'}}
						</template>
					</c-table-column>
					
				</c-table>
				<div style="height:20px;"></div>
				<c-table v-if="cusTomList.length > 0" :data="cusTomList" height="auto" :paging="false" border>
					<c-table-column
						label="定制项"
						width="200"
					>
						<template v-slot="{data}">
							<span v-if="data.item_type==1" style="font-weight:bold;color:chocolate">{{data.custom_name}}</span>
							<span v-if="data.item_type!=1">{{data.custom_name}}</span>
						</template>
					</c-table-column>
					
					<c-table-column
						label="定制内容"
						width="260"
					>
						<template v-slot="{data}">
<!--							<c-file v-if="data.item_type==1" :src="data.custom_value" media ></c-file>-->
							<span>{{data.custom_value}}</span>
						</template>
					</c-table-column>
					
					<c-table-column
						label="定制数量"
						width="80"
					>
						<template v-slot="{data}">
							×{{data.product_count}}
						</template>
					</c-table-column>
					
					<c-table-column
						label="定制费用单价(报价)"
						width="140"
					>
						<template v-slot="{data}">
							{{parseFloat(data.product_price_cost).toFixed(2)}}
						</template>
					</c-table-column>
					
					<c-table-column
						label="定制费用小计(报价)"
						width="140"
					>
						<template v-slot="{data}">
							{{parseFloat(data.product_price_cost_money).toFixed(2)}}
						</template>
					</c-table-column>
					
				</c-table>
			</div>
			
			<template slot="button">
				<c-button color="main"
                          v-if=" orderDetail.delivery_state == 1 && orderDetail.refunding_count==0 && orderDetail.returning_count==0 && orderDetail.check_state == 2 && (orderDetail.order_state == 2 || (orderDetail.order_state == 3 && orderDetail.deliver_state =='部分发货'))"
                          size="form" @click="$refs.orderProductSend.open(orderDetail.order_number)">发货</c-button>
				<c-button size="form" @click="showRemarkList">查看客服备注</c-button>
			</template>
		</module>
		
		<!--客服备注弹框（列表） -->
		<c-dialog ref="remarkList" title="客服备注" width="700" :button="false">
			<c-table :data="remarkList" height="400" :paging="false" border>
				<c-table-column
					label="备注人"
					name="create_user_realname"
					width="80"
				></c-table-column>
				
				<c-table-column
					label="备注内容"
					name="customer_service_remark"
					width="280"
				></c-table-column>
				
				<c-table-column
					label="备注时间"
					name="create_date"
				></c-table-column>
			</c-table>
		</c-dialog>
        <!--订单发货-->
        <order-product-send ref="orderProductSend" @resolve="getOrderDetail()"></order-product-send>
    </page>
</template>

<script>
	import productInfo from '@/components/public/product_info.vue'
    import orderProductSend from '@/components/service/order_product_send.vue'  // 订单发货

    export default {
		components: {
			productInfo,orderProductSend
		},
		
		props: {
			orderNumber: String
		},
		
		data() {
			return {
				orderDetail: '',
				productList: [],
				giftProductList: [],
				cusTomList: [],
				cusTomInfo:'',
				invoiceDate:'',
				realityMoney: 0,
				orderRemark: '',
				remarkList: [],
				cancel_reason: '',
				order_remark: ''
			}
		},
		
		computed: {
            waitSendProductTotal() {
                var total_product_count = 0
                this.productList.forEach(item => {
                    if ((item.product_count - item.send_count - item.total_refund_count) > 0){
                        total_product_count += (item.product_count - item.send_count - item.total_refund_count);
                    }else {
                        total_product_count += (item.product_count - item.send_count - item.total_refund_count);
                    }
                });
                return total_product_count;
            }
		},
		
		watch: {
			orderNumber() {
				this.getOrderDetail();
			}
		},
		
		mounted() {
			this.getOrderDetail();
		},
		
		methods: {
			//获取订单详情数据，按商家查询
			getOrderDetail() {
				this.request({
					url: '/order/detail_delivery',
					data: {
						order_number: this.orderNumber
					},
					loading: true,
					success: data => {
						this.orderDetail = data.base_info;
						this.order_remark = this.orderDetail.order_remark;
						this.productList = data.product_sku_info;
						this.giftProductList = data.gift_product_list;
						this.cusTomList = data.custom_list||[];
						this.cusTomInfo = data.custom_info||{};
					}
				});
			},

			//显示客服备注
			showRemarkList() {
				this.request({
					url: '/order/query_customer_service_remark_list',
					data: {
						order_number: this.orderNumber
					},
					loading: true,
					success: data => {
						this.remarkList = data;
						this.$refs.remarkList.open();
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.order {
		&-info {
			width: 500px;
			padding: 30px 30px;
			
			dt {
				border-left: 3px solid #000;
				padding-left: 5px;
				margin-bottom: 26px;
				line-height: 18px;
				font-size: 16px;
				font-weight: bold;
			}
			
			&-item {
				padding: 9px 0;
				line-height: 20px;
				font-size: 13px;
				
				label {
					min-width: 5em;
					color: #666;
					text-align: right;
				}
				
				p {
					a {
						color: #005CD9;
					}
				}
			}
		}
		
		&-detail {
			padding: 30px 30px 40px;
		}
		
		&-total {
			height: 45px;
			padding: 0 16px;
			font-size: 13px;
			color: #000;
			background: #FAFAFA;
			
			span {
				color: var(--color-main);
			}
			
			b {
				font-size: 16px;
			}
		}
		
		&-remark {
			padding: 20px;
			
			textarea {
				box-sizing: border-box;
				width: 100%;
				height: 200px;
				border: none;
				padding: 10px 14px;
				line-height: 20px;
				background: #FAFAFA;
				resize: none;
			}
		}
	}

	.logistics {
		&-order {
			padding: 14px 18px;
			
			li {
				border: 1px solid #ddd;
				padding: 0 26px;
				line-height: 42px;
				font-size: 14px;
				color: #666;
				cursor: pointer;
				
				&:nth-child(n+2) {
					margin-left: 20px;
				}
				
				&:hover {
					background: #F0F3FC;
				}
				
				&.z-crt {
					border-color: #005CD9;
					color: #005CD9;
					background: #F0F3FC;
				}
			}
		}
		
		&-list {
			height: 434px;
			padding: 20px;
			overflow: auto;
			background: #FAFAFA;
			
			li {
				padding: 10px 0;
				line-height: 24px;
				font-size: 13px;
				color: #333;
				
				label {
					margin-right: 16px;
					color: #666;
				}
			}
		}
	}
	.invoice-info {
		max-width: 1000px;
		padding: 30px 0;
		
		dt {
			border-left: 3px solid #000;
			padding-left: 5px;
			margin-bottom: 26px;
			line-height: 18px;
			font-size: 16px;
			font-weight: bold;
		}
		
		dd > div:nth-child(1) {
			margin-right 50px;
		}
		
		&-item {
			padding: 9px 0;
			line-height: 20px;
			font-size: 13px;
			
			label {
				min-width: 7em;
				color: #666;
				text-align: right;
			}
			
			p {
				a {
					color: #005CD9;
				}
			}
		}
	}
	
	.invoice {
		font-size: 14px;
		color: #000;
		
		p {
			color:#666;
			height:30px;
		}
	}
</style>